<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30.924"
    height="15.024"
    viewBox="0 0 30.924 15.024"
  >
    <g transform="translate(-1097.406 -582.738)">
      <g>
        <path
          d="M1121.911,597.762h-18.443l.03-.534a54.958,54.958,0,0,1,1.171-8.671l.53.03.2-.144a4.115,4.115,0,0,0,.99.847c.615.443,1.85-.3,2.5-.8l-.917-2.708.857.38a43.182,43.182,0,0,1,4.872,2.545,17.231,17.231,0,0,0,4.016,1.563,13.171,13.171,0,0,1,3.448,1.352c1.794,1.256.868,5.584.828,5.767Zm-17.579-1h16.958c.215-1.231.415-3.61-.519-4.264a12.926,12.926,0,0,0-3.238-1.251,17.631,17.631,0,0,1-4.185-1.639,41.681,41.681,0,0,0-3.921-2.1l.461,1.361-.266.232c-.237.2-2.344,1.989-3.629,1.059-.3-.217-.533-.4-.712-.554a53.532,53.532,0,0,0-.952,7.156Z"
        />
        <rect
          width="17.919"
          height="1"
          transform="translate(1104.046 594.308)"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(1111.109 590.736) rotate(-60.477)"
        />
        <rect
          width="2.484"
          height="1"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 1112.757, 591.46)"
        />
      </g>
      <path
        d="M1123.073,592.291c-.057,0-.114,0-.169-.005a.5.5,0,0,1-.473-.524.472.472,0,0,1,.524-.474,13.673,13.673,0,0,0,4.36-1.15c-.029-.7-.092-2.253-.109-3.019a15.41,15.41,0,0,0-.855-2.828c-.113-.44-.53-.493-1.276-.473-.115,0-.217.006-.3.005-.1,0-.231-.018-.378-.037-.263-.034-.753-.1-.9.029a.4.4,0,0,0-.067.281c.005.586.093.684.1.694a2.315,2.315,0,0,0,.779.032,2.15,2.15,0,0,1,1.958.872.5.5,0,0,1,.1.3v2.3a.5.5,0,0,1-.5.5h0a28.987,28.987,0,0,1-3.179-.136.49.49,0,0,1-.228-.126.557.557,0,0,0-.391-.14,4.894,4.894,0,0,0-2.419,1.51.5.5,0,1,1-.722-.691c.174-.183,1.751-1.79,3.12-1.819a1.6,1.6,0,0,1,.979.311c.363.045,1.357.076,2.342.087v-1.615a1.15,1.15,0,0,0-.97-.353,1.959,1.959,0,0,1-1.545-.3,1.893,1.893,0,0,1-.422-1.416,1.3,1.3,0,0,1,.4-1.038,2.111,2.111,0,0,1,1.688-.273c.107.014.2.027.276.029s.15,0,.242,0c.645-.018,1.959-.062,2.257,1.163a15.469,15.469,0,0,1,.9,3.034c.031,1.078.132,3.424.133,3.425a.5.5,0,0,1-.3.48A16.8,16.8,0,0,1,1123.073,592.291Z"
      />
      <path
        d="M1102.665,592.29a16.76,16.76,0,0,1-4.958-1.371.5.5,0,0,1-.3-.48s.1-2.346.124-3.342a15.863,15.863,0,0,1,.93-3.188c.273-1.155,1.595-1.116,2.236-1.091.091,0,.174,0,.24,0s.168-.015.275-.029a2.1,2.1,0,0,1,1.688.273,1.3,1.3,0,0,1,.4,1.038,1.464,1.464,0,0,1-1.944,1.715,1.206,1.206,0,0,0-.994.351v1.615c.975-.011,1.958-.041,2.33-.086.63-.579,1.125-.8,1.527-.708a.711.711,0,0,1,.509.438.5.5,0,0,1-.769.569,2.774,2.774,0,0,0-.688.529.49.49,0,0,1-.228.126,29.005,29.005,0,0,1-3.179.136h0a.5.5,0,0,1-.5-.5v-2.3a.5.5,0,0,1,.1-.3,2.162,2.162,0,0,1,1.982-.87,2.221,2.221,0,0,0,.755-.034c.01-.01.1-.108.1-.694a.4.4,0,0,0-.068-.281c-.143-.127-.632-.064-.9-.029-.147.019-.278.034-.379.037-.082,0-.184,0-.3-.005-.744-.02-1.165.033-1.254.4a15.673,15.673,0,0,0-.888,2.983c-.009.7-.072,2.244-.1,2.936a13.946,13.946,0,0,0,4.36,1.151.471.471,0,0,1,.525.474.5.5,0,0,1-.474.524C1102.778,592.288,1102.722,592.29,1102.665,592.29Z"
      />
      <rect
        width="1"
        height="1.153"
        transform="translate(1124.193 584.296)"
      />
      <rect
        width="1"
        height="1.153"
        transform="translate(1100.541 584.296)"
      />
    </g>
  </svg>
</template>
